import { createContext, useState, useEffect } from 'react'
import { ipLookup, getIpAddress } from 'services/api/ip'

export const IpContext = createContext()

const IpContextProvider = (props) => {
  const [ipCountry, setIpCountry] = useState(null)
  const [ipLoading, setIpLoading] = useState(false)

  const fetchData = async () => {
    try {
      setIpLoading(true)
      await getIpAddress().then(async (res) => {
        if (res) {
          console.log(`🔍 Detected IP: ${res}`)
          await ipLookup(res).then((res) => {
            console.log(`Detected Country: ${res.country}`)
            setIpCountry(res.country)
          })
        }
      })
    } catch (e) {
      console.error('IP Lookup Error:', e)
    } finally {
      setIpLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <IpContext.Provider
      value={{
        ipCountry,
        ipLoading,
      }}
    >
      {props.children}
    </IpContext.Provider>
  )
}

export default IpContextProvider
